import {useTheme} from "@mui/material";
import {useEffect, useState} from "react";

export default function useResponsive() {
    const [screen, setScreen] = useState<string>();
    const theme = useTheme();
    const screenSize = (w: number): string | undefined => {
        const {md, sm} = theme.breakpoints.values;
        const screenSizes: { [key: string]: boolean } = {
            sm: w <= sm,
            md: w > sm && w <= md,
            lg: w > md,
        };
        const screenSize = Object.keys(screenSizes).find((x) => !!screenSizes[x]);
        return screenSize;
    };

    useEffect(() => {
        setScreen(screenSize(window.innerWidth));
    }, []);

    useEffect(() => {
        window.addEventListener("resize", () => {
            const sc = screenSize(window.innerWidth);
            sc !== screen && setScreen(sc);
        });
    }, [screen]);

    return {
        screen,
        isLoading: screen === undefined,
        isMobile: screen === "sm",
        isTablet: screen === "md",
        isDesktop: screen === "lg",
    };
}
